import { keepPreviousData, useQuery } from "@tanstack/react-query"
import { useEffect, useState } from "react"
import { type AudienceFilter, audienceKeys, listAudience } from "@/entities/audience"
import { broadcastKeys, countBroadcastRecipients } from "@/entities/broadcast"

function useDebounced<T>(value: T, delayMs: number): T {
	const [debounced, setDebounced] = useState(value)
	useEffect(() => {
		const timer = window.setTimeout(() => setDebounced(value), delayMs)
		return () => window.clearTimeout(timer)
	}, [value, delayMs])
	return debounced
}

export function useRecipientCount(botId: string, filter: AudienceFilter, enabled: boolean) {
	const debounced = useDebounced(filter, 300)
	return useQuery({
		queryKey: broadcastKeys.count(botId, debounced),
		queryFn: () => countBroadcastRecipients(botId, debounced),
		enabled,
		placeholderData: keepPreviousData,
	})
}

const SAMPLE_SIZE = 5

/** Несколько получателей по имени: видно, что фильтр выбрал тех, кого нужно. */
export function useRecipientSample(botId: string, filter: AudienceFilter, enabled: boolean) {
	const debounced = useDebounced(filter, 300)
	return useQuery({
		queryKey: [...audienceKeys.list(botId, debounced), "sample"],
		queryFn: async () => {
			const page = await listAudience(botId, debounced, { skip: 0, take: SAMPLE_SIZE * 3 })
			// Заблокировавшим рассылка не уходит, в примерах их не показываем.
			return page.items.filter((member) => member.state !== "BLOCKED").slice(0, SAMPLE_SIZE)
		},
		enabled,
		placeholderData: keepPreviousData,
	})
}
